<template>
	<div class="tick-box">
		<label>{{label}}</label>
		<div v-for='tick in elements'>
			<label><input type="checkbox" :checked="curres.indexOf(tick)!=-1" @input="change(tick)"/> {{tick}}</label>
		</div>
	</div>
</template>

<script>
export default {
	props:{
		"value":{type:Array, default(){return []}},
		"elements":{type:Array, default(){return [1,2,3]}},
		"label":{type:String}
},
  name: 'i-tick-box',
  mounted(){
    if(this.value){
      this.curres = this.value;
      console.log(this.curres)
    }
  },
  methods:{
  	change(tick){
  		let {curres} = this;
  		let index = curres.indexOf(tick);
  		if(curres.indexOf(tick)!=-1){
  			curres.splice(index, 1);
  		} else {
  			curres.push(tick);
  		}
  		this.$emit('input',curres);
  	}
  },
  data () {
    return {
      curres:[]
    }
  }
}
</script>

<style lang="css" scoped>
</style>